import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { PedidoService } from '../../service/pedido.service';
import { FiltroControleLogistico, getFiltroControleLogisticoDefault, getProgPedidoDtoDefault, ProgPedidoDto, ProgPedidoDtoList } from '../../interface/pedido';
import { FiltroProgPedidoLista } from '../filtro/filtro-lista-programacao-pedido';
import { ExcelService } from 'src/app/service/excel-service';

@Component({
  selector: 'app-pedido-venda-programacao',
  templateUrl: './pedido-venda-programacao.component.html',
  styleUrl: './pedido-venda-programacao.component.css'
})
export class PedidoVendaProgramacaoComponent implements OnInit {

  tabelaPrincipalItens: ProgPedidoDtoList = {items:[]};
  tabelaPrincipalFiltro: FiltroProgPedidoLista;

  pedidoSelecionado: ProgPedidoDto = getProgPedidoDtoDefault();
  controleLogistico: FiltroControleLogistico = getFiltroControleLogisticoDefault();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
    private pedidoService: PedidoService,
    private excelService: ExcelService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroProgPedidoLista(this.poStorageService);
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('alteraPedidoModal', { static: true }) alteraPedidoModal!: PoModalComponent;
  @ViewChild('controleLogisticoModal', { static: true }) controleLogisticoModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }
  
  actionPage: Array<PoPageAction> = [
    {label: 'Controle Logístico', action: this.controleLogisticoAction.bind(this)}
  ]

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.pedidoService.listaProgPedidos(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens.items = lista.items.map((item) => {
        return { ...item, favorite: ['edit'] };
      });
      console.log(this.tabelaPrincipalItens);
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CC5NUM'       , label: 'Pedido'       , width: '10%'},
    {property: 'CC5CLIENTE'   , label: 'Cod Cliente'  , width: '10%'},
    {property: 'CC5LOJACLI'   , label: 'Loja'         , width: '10%'},
    {property: 'CA1NREDUZ'    , label: 'Cliente'      , width: '30%'},
    {property: 'DC5EMISSAO'   , label: 'Dt. Emissão'  , width: '10%', type: 'date', format: 'dd/MM/yyyy' },
    {property: 'NC5XDSEMAN'   , label: 'Semana'       , width: '10%'},
    {property: 'DC5FECENT'    , label: 'Dt. Prev. Entrega' , width: '10%', type: 'date', format: 'dd/MM/yyyy' },
    {property: 'favorite'     , label: '...'     , width: '10%', type: 'icon',
      icons: [
        {
          action: this.edit.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'Editar',
          value: 'edit',
        }
      ]
    }
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Pedido de Venda', action: this.goHome.bind(this) },
      { label: 'Programação' }
    ]
  };

  edit(row: ProgPedidoDto): void {
    this.pedidoSelecionado = row;
    this.alteraPedidoModal.open();
  }

  public readonly alteraPedidoPrimaryAction: PoModalAction = {
    action: () => {
      this.alteraPedidoModal.close();
      this.salvarPedido(this.pedidoSelecionado);
    },
    label: 'Salvar'
  };

  salvarPedido(pedido: ProgPedidoDto): void {
    this.pedidoService.postProgPedido(pedido).subscribe((ret) => {
      this.poNotificationService.success("Pedido alterado com sucesso");
      this.tabelaPrincipalLoad();
    })
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  controleLogisticoAction(): void {
    this.controleLogistico = getFiltroControleLogisticoDefault();
    this.controleLogisticoModal.open();
  }

  public readonly controleLogisticoPrimaryAction: PoModalAction = {
    action: () => {
      this.pedidoService.getControleLogistico(this.controleLogistico).subscribe((ret) => {
        let lista_excel = ret.items.map((item)=>{
            return {
              'Status': this.getStatusDesc(item.CZ00STATUS),
              'Nº Cont': item.CZ02CTNR,
              'Booking': item.CEECBKAGEN?item.CEECBKAGEN+" / "+item.CEECBOOK:"",
              'Nome Cliente': item.CA1NREDUZ,
              'Romaneio': item.CZ00COD,
              'Processo': item.CZ00PROCES,
              'Ordem': item.CEE7PEDIDO,
              'Container': item.CZ00COTNER,
              'Tara': item.NZ00TARA,
              'Lacre': item.CZ00SELOD,
              'Nota Fiscal': item.CZ00NOTA,
              'Transportadora': item.CA4NOME,
              'Dt. Carregamento': item.DZ00DTACAR,
              'Terminal de Apoio': item.CZ00TERMIN,
              'Dt. Depósito Term. de Apoio': item.DZ00DTETER,
              'Data de Entrada Porto': item.DZ00DTEPOR   ,
            }
          });
          this.excelService.exportAsExcelFile(lista_excel,`ControleLogistico`)
      })
      this.controleLogisticoModal.close();
    },
    label: 'Gerar'
  };

  getStatusDesc(codigo: string): string {
    if(codigo == "0") {
      return "Disp. Romaneio";
    } else if(codigo == "1") {
      return "Lib. Comercial";
    } else if(codigo == "2") {
      return "Pendente NFs";
    } else if(codigo == "3") {
      return "Fat. sem Dados";
    } else if(codigo == "4") {
      return "A Carregar";
    } else if(codigo == "5") {
      return "Carregamento Autorizado";
    } else if(codigo == "6") {
      return "Carregado";
    } 
    return "Finalizado";
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

  

}